module.exports = __webpack_public_path__ + "img/formSection_img2.ea99ebcf.png";